export const VALID_MOBILE_NUMBER = 'Please provide a valid mobile number';
export const VALID_MOBILE_NUMBER_EMAIL_ID = 'Please provide a valid mobile number or email ID';
export const VALID_EMAIL = 'Please provide a valid email ID';
